const LiveAgentStepEnum = Object.freeze({
    OVERVIEW: 0,
    INSIGHTS: 1,
    QUICK_RESPONSES: 2,
    SETTINGS: 3
});

export { LiveAgentStepEnum };